<template>
  <div>
    <span
      v-if="String(filtros[0]) === String(item[item_key])"
      v-text="getPrimeiraPalavraString(item[item_value])"
    />

    <span
      v-if="filtros.length > 1 && String(filtros[1]) === String(item[item_key])"
      class="ml-1 text-gray-100"
      v-text="`(+ ${filtros.length - 1})`"
    />
  </div>
</template>

<script>
export default {
  name: "TextoOutrosFiltrosSelecionadosAutocomplete",
  props: {
    filtros: Array,
    item: Object,
    item_key: {
      type: String,
      default: 'id'
    },
    item_value: {
      type: String,
      default: 'descricao'
    },
    retornar_texto_completo: Boolean
  },
  methods: {
    getPrimeiraPalavraString(str) {
      if (this.retornar_texto_completo) return str;

      const [primeira_palavra] = String(str).split(' ');
      return primeira_palavra || '';
    }
  }
}
</script>

<style scoped>

</style>
